<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput";
import DateTime from "@/pages/components/form/input-only/datetime.vue";
import Input from "@/pages/components/form/input-only/color.vue";
import dateProps from '@/mixins/shared/dateProps'

export default {
	mixins: [formInput,dateProps],
	components: {Input, FormGroup, DateTime},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	}
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label">
			{{ label }}
		</template>

		<DateTime
			v-bind="$attrs"
			:name="name"
			:form="form"
			:id="renderedId"
			:model-value="modelValue"
			@update:modelValue="changeModelValueTo"
		>
			<template #addonbefore v-if="$slots.addonbefore"><slot name="addonbefore" /></template>
			<template #addonafter v-if="$slots.addonafter"><slot name="addonafter" /></template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</DateTime>
	</FormGroup>
</template>